import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onGetForm, onGetOne, onSave } from 'redux/actions/marriages.actions';
import {
  marriageFormSelector,
  marriagesCementeriesSelector,
  marriagesCivilStatesSelector,
  marriagesFilesSelector,
  marriagesIdCardTypesSelector,
  marriagesTribesSelector,
} from 'redux/selectors/marriages.selector';

import LayoutContainer from 'containers/LayoutContainer';
import MarriagesForm from 'views/public/MarriagesView/components/MarriagesForm';
import Loading from 'components/commons/Loading';

import { IMarriagesFormData } from 'views/public/MarriagesView/components/MarriagesForm/types';

import 'views/public/MarriagesView/components/MarriagesForm/i18n';

const MarriagesFormContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id = '' } = useParams<{ id?: string }>();
  const initialValues = useTypedSelector(marriageFormSelector);
  const { loading } = useTypedSelector((state) => state.marriages);
  const cementeries = useTypedSelector(marriagesCementeriesSelector);
  const civilStates = useTypedSelector(marriagesCivilStatesSelector);
  const idCardTypes = useTypedSelector(marriagesIdCardTypesSelector);
  const tribes = useTypedSelector(marriagesTribesSelector);
  const files = useTypedSelector(marriagesFilesSelector);
  const isEditing = !!id;

  useEffect(() => {
    dispatch(onGetForm());
    if (id) dispatch(onGetOne(id));
    return () => {
      dispatch(onGetOne(''));
    };
  }, [dispatch, id]);

  const onSubmit = (formData: IMarriagesFormData) => dispatch(onSave(formData, id));

  return (
    <LayoutContainer isPublic title={i18next.t<string>('PUBLIC_PROCEDURES_VIEW:TITLE')}>
      <MarriagesForm
        cementeries={cementeries}
        civilStates={civilStates}
        files={files}
        idCardTypes={idCardTypes}
        initialValues={initialValues}
        isEditing={isEditing}
        onSubmit={onSubmit}
        tribes={tribes}
      />
      {loading && <Loading isModalMode message={i18next.t('MARRIAGES_FORM:LOADING')} />}
    </LayoutContainer>
  );
};

export default MarriagesFormContainer;
